const permissions = () => [
  {
    ordem: 0,
    name: 'Dashboard',
    path: '/app/dashboard',
    typeUser: 'parceiro'
  },
  {
    ordem: 1,
    name: 'Minha conta',
    path: '/app/myAccount',
    typeUser: 'parceiro'
  },
  {
    ordem: 2,
    name: 'Validar token',
    path: '/app/TokenValidation',
    typeUser: 'parceiro'
  },
  {
    ordem: 3,
    name: 'Usuários',
    path: '/app/users',
    typeUser: 'parceiro'
  },
  {
    ordem: 4,
    name: 'Permissões padrões',
    path: '/app/permissions',
    typeUser: 'gestao'
  },
  {
    ordem: 5,
    name: 'Associados',
    path: '/app/clients',
    typeUser: 'gestao'
  },
  {
    ordem: 6,
    name: 'Parceiros',
    path: '/app/partners',
    typeUser: 'gestao'
  },
  {
    ordem: 7,
    name: 'Empresas',
    path: '/app/companies',
    typeUser: 'gestao'
  },
  {
    ordem: 8,
    name: 'Comodidades',
    path: '/app/Amenities',
    typeUser: 'gestao'
  },
  {
    ordem: 9,
    name: 'Categorias',
    path: '/app/category',
    typeUser: 'gestao'
  },
  {
    ordem: 10,
    name: 'Meu espaço',
    path: '/app/MySpace',
    typeUser: 'parceiro'
  },
  {
    ordem: 11,
    name: 'Produtos',
    path: '/app/products',
    typeUser: 'gestao'
  },
  {
    ordem: 12,
    name: 'Tabelas',
    path: '/app/tables',
    typeUser: 'gestao'
  },
  {
    ordem: 13,
    name: 'Repasses',
    path: '/app/transfers',
    typeUser: 'gestao'
  },
  {
    ordem: 14,
    name: 'Reajustes',
    path: '/app/readjustments',
    typeUser: 'gestao'
  },
  {
    ordem: 15,
    name: 'Contas a pagar',
    path: '/app/billsToPay',
    typeUser: 'gestao'
  },
  {
    ordem: 16,
    name: 'Contas a receber',
    path: '/app/billsToReceive',
    typeUser: 'gestao'
  },
  {
    ordem: 17,
    name: 'Meu Extrato',
    path: '/app/myFinancialStatement',
    typeUser: 'parceiro'
  },
  {
    ordem: 18,
    name: 'Competências',
    path: '/app/competence',
    typeUser: 'gestao'
  },
  {
    ordem: 19,
    name: 'Gerar faturamento',
    path: '/app/generateBilling',
    typeUser: 'gestao'
  },
  {
    ordem: 20,
    name: 'Manutenção de faturamento',
    path: '/app/maintenanceBilling',
    typeUser: 'gestao'
  },
  {
    ordem: 21,
    name: 'Tokens utilizados',
    path: '/app/reports/RepUsedTokens',
    typeUser: 'parceiro'
  },
  {
    ordem: 22,
    name: 'Relatório de vendas',
    path: '/app/reports/repSales',
    typeUser: 'gestao'
  },
  {
    ordem: 23,
    name: 'Documentaçāo',
    path: '/app/DocsPartners',
    typeUser: 'parceiro'
  },
  {
    ordem: 23,
    name: 'Check-In',
    path: '/app/CheckIn',
    typeUser: 'parceiro'
  }
];

export default permissions;
